import { render, staticRenderFns } from "./CompanyInfoFormTab.vue?vue&type=template&id=77562306&"
import script from "./CompanyInfoFormTab.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoFormTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports